
import React, { useEffect, useState } from "react";
import axios from "axios";
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, Button, TextField, Select, MenuItem, 
  Tabs,
  Tab
} from "@mui/material";
import AdminToolbar from "../../Toolbar/AdminToolbar";
import Box from '@mui/material/Box';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ActiveUser from "./ActiveUser";
import AccessRevoked from "./AccessRevoked";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL; 

const ManageUser = () => {
  const [users, setUsers] = useState([]);
  const [distinctRoles, setDistinctRoles] = useState([]);
  const [newUser, setNewUser] = useState({ emailId: "", role: "" });
  const [addingUser, setAddingUser] = useState(false); 

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/users`)
      .then((response) => {
        setUsers(response.data.users);
        setDistinctRoles(response.data.distinctRoles);
      })
      .catch((error) => console.error("Error fetching users:", error));
  }, []);

  const handleAddUser = async () => {
    if (!newUser.emailId || !newUser.role) {
      alert("Please enter email and role.");
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/api/users`, newUser);
      setUsers([response.data.user, ...users]); 
      setNewUser({ emailId: "", role: "" }); 
      setAddingUser(false); 
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const toggleAccess = async (userId, isActive) => {
    try {
      await axios.put(`${API_BASE_URL}/api/users/${userId}`, { active: !isActive });
      setUsers(users.map((user) => (user._id === userId ? { ...user, active: !isActive } : user)));
    } catch (error) {
      console.error("Error updating user access:", error);
    }
  };
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
        setValue(newValue);
    }
};

  return (
<>      <AdminToolbar/>
     
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Active Access" value="1" />
            <Tab label="Revoked Access" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1"><ActiveUser/></TabPanel>
        <TabPanel value="2"><AccessRevoked/></TabPanel>
      </TabContext>

     
   
   </>
  );
};

export default ManageUser;
